import React from 'react'

import './Details.css'

class DetailsPanel extends React.Component {
    render() {
        return (
            <div className="detailsPanel">
                <div className="row">
                    <div className="col-md-12">
                        <div className="details-blk header-top">
                            <p className="details-blk-hdg">User Info</p>

                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">User:</p>
                                    <span>{this.props.user.userName}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">10 Character ID:</p>
                                    <span>{this.props.user.userName.substr(0, 10)}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">UPN User Principal Name:</p>
                                    <span>{this.props.user.userPrincipalName}</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">First Name:</p>
                                    <span>{this.props.user.firstName}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Middle Name:</p>
                                    <span>{this.props.user.middleName}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Last Name:</p>
                                    <span>{this.props.user.lastName}</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <span className="blk-label">Status:</span>
                                    <select id="status" name="isActive" defaultValue={this.props.user.isActive ? 'Active' : 'Inactive'} onChange={this.props.onDetailsUpdate}>
                                        <option>Active</option>
                                        <option>Inactive</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">AD Status:</p>
                                    {
                                        this.props.user.adEnabled == null ?
                                            <span>Does Not Exist</span>
                                        :
                                            this.props.user.adEnabled ?
                                                <span>Enabled</span>
                                            :
                                                <span>Disabled</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="details-blk">
                            <p className="details-blk-hdg">Contact Info</p>

                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">Office Telephone:</p>
                                    <span>{this.props.user.officePhone}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Office Extension:</p>
                                    <span>{this.props.user.officeExt}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Office Fax:</p>
                                    <span>{this.props.user.officeFax}</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">Mobile Telephone:</p>
                                    <span>{this.props.user.mobilePhone}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Other Mobile:</p>
                                    <span>{this.props.user.otherMobile}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">House Telephone:</p>
                                    <span>{this.props.user.housePhone}</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">Email:</p>
                                    <span>{this.props.user.email}</span>
                                </div>
                           </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="details-blk">
                            <p className="details-blk-hdg">Address Info</p>

                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">Address1:</p>
                                    <span>{this.props.user.addressInformation ? this.props.user.addressInformation.addressLine1 : null}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Address2:</p>
                                    <span>{this.props.user.addressInformation ? this.props.user.addressInformation.addressLine2 : null}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">City:</p>
                                    <span>{this.props.user.addressInformation ? this.props.user.addressInformation.city : null}</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">State:</p>
                                    <span>{this.props.user.addressInformation ? this.props.user.addressInformation.stateCode : null}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Zip:</p>
                                    <span>{this.props.user.addressInformation ? this.props.user.addressInformation.postalCode : null}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Country:</p>
                                    <span>{this.props.user.addressInformation ? this.props.user.addressInformation.country : null}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="details-blk">
                            <p className="details-blk-hdg">Organizational Info</p>

                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">Department:</p>
                                    <span>{this.props.user.department}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Job Title:</p>
                                    <span>{this.props.user.title}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Location:</p>
                                    <span>{this.props.user.location}</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">Manager:</p>
                                    <span>{this.props.user.manager}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Houzz URL:</p>
                                    <span>{this.props.user.houzzUrl}</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Credentials:</p>
                                    <span>{this.props.user.credentials}</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p className="blk-label">Employee GUID:</p>
                                    <span>{this.props.user.employeeGUID}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DetailsPanel